<div class="item-container">
  <div class="item-header">
    <h5 class="text-center">{{"COMMON.ADD" | translate}} {{"RECRUITER.MULTIPLESHIFTS" | translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content shift-container">
    <table class="mt-4" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 normal-td">
      <ng-container matColumnDef="No.">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let element;let i=index">{{i+1}}</td>
      </ng-container>
      <ng-container matColumnDef="job_name">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.JOBNAME" | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <input type="text" class="form-control" placeholder="Job Name" [(ngModel)]="element.j_n">
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.DATE" | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="in-box">
            <input class="form-control" [matDatepicker]="sDate" placeholder="Select Date" [(ngModel)]="element.st_dt" />
            <mat-datepicker-toggle matIconSuffix [for]="sDate"></mat-datepicker-toggle>
            <mat-datepicker #sDate></mat-datepicker>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="qty">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.QTY" | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <input type="number" class="form-control" placeholder="Quantity" [(ngModel)]="element.qty">
        </td>
      </ng-container>
      <ng-container matColumnDef="start_time">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.STARTTIME" | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="in-time-box">
            <i class="material-icons">access_time</i>
            <input class="form-control" [ngxTimepicker]="startTime" [format]="24" readonly
              [(ngModel)]="element.st_ti" />
            <ngx-material-timepicker #startTime></ngx-material-timepicker>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="end_time">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.ENDTIME" | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="in-time-box">
            <i class="material-icons">access_time</i>
            <input class="form-control" [ngxTimepicker]="endTime" [format]="24" readonly [(ngModel)]="element.ed_ti" />
            <ngx-material-timepicker #endTime></ngx-material-timepicker>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="instant_hire">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.INSTANTHIRE" | translate}} </th>
        <td mat-cell *matCellDef="let element;let i=index">
          <div class="mt-3 me-4">
            <mat-slide-toggle color="primary" class="mb-0 slide-1" 
            [ngModel]="element.ins_h == 1"
              (ngModelChange)="element.ins_h = $event ? 1 : 0"> </mat-slide-toggle>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.CATEGORY" | translate}} </th>
        <td mat-cell *matCellDef="let element;let i=index">
          <mat-select class="form-control" placeholder="Select Category" [(ngModel)]="element.j_c"
            (selectionChange)="onSelectCategory($event,element,i)">
            <mat-option [value]="item.j_c" *ngFor="let item of categoryArr">{{item.j_c}}</mat-option>
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="sub_category">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.SUBCATEGORY" | translate}} </th>
        <td mat-cell *matCellDef="let element;let i=index">
          <mat-select class="form-control" placeholder="Select Sub Category" [(ngModel)]="element.j_sc"
            (selectionChange)="onSelectSubCat(element,i)">
            <mat-option *ngFor="let item of element.sub_c" [value]="item.j_sc">{{item.j_sc}}</mat-option>
          </mat-select>
        </td>
      </ng-container>
      <ng-container *ngIf="userInfo.u_typ != 0" matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"COMMON.COMPANY"|translate}} </th>
        <td mat-cell *matCellDef="let element;let i=index">
          <mat-select class="form-control" placeholder="Select Company" [(ngModel)]="element.co_i"
            (selectionChange)="onSelectCompany($event,i)">
            <mat-option *ngFor="let item of companyArr" [value]="item.co_i">{{item.company_name}}</mat-option>
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.LOCATION" | translate}} </th>
        <td mat-cell *matCellDef="let element,let i=index">

          <mat-select *ngIf="userInfo.u_typ == 0" class="form-control" placeholder="Select Location"
            [(ngModel)]="element.add" (selectionChange)="onSelectLocation(element,i ,'co')">
            <mat-option *ngFor="let item of locArr" [value]="item.add">{{item.add}}</mat-option>
          </mat-select>
          <mat-select *ngIf="userInfo.u_typ != 0" class="form-control" placeholder="Select Location"
            [(ngModel)]="element.add" (selectionChange)="onSelectLocation(element,i ,'ot')">
            <mat-option *ngFor="let item of element.locArr" [value]="item.add">{{item.add}}</mat-option>
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="experience">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"Experience (In year)" | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <input type="number" class="form-control" placeholder="Experience" [(ngModel)]="element.experience">
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="emplloyee_t">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"Show Employee" | translate}} </th>
        <td mat-cell *matCellDef="let element,let i=index">
          <mat-slide-toggle color="primary" class="mb-0 slide-1" [(ngModel)]="element.showEmployee"></mat-slide-toggle>
        </td>
      </ng-container> -->
      <ng-container matColumnDef="employee">
        <th mat-header-cell *matHeaderCellDef class="user">{{"RECRUITER.ADDSHIFT.EMPLOYEE" | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex gap-2">
            <mat-slide-toggle color="primary" class="mb-0 slide-1"
              [(ngModel)]="element.showEmployee"></mat-slide-toggle>
            <div style="min-width: 250px;" *ngIf="element.showEmployee">
              <ng-select [items]="element.filterEmployeeArr" bindLabel="first_name" [searchFn]="customSearchFn"
                bindValue="em_i" [multiple]="true" placeholder="Select Employee" [editableSearchTerm]="true"
                [closeOnSelect]="false" groupBy="e" [selectableGroup]="true" [selectableGroupAsModel]="false"
                [(ngModel)]="element.emp">
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                  <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                    [ngModelOptions]="{standalone: true}" /> Select All
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="d-flex align-items-center em-box">
                    <input id="item-{{ index }}" type="checkbox" value="surat" [ngModel]="item$.selected"
                      [ngModelOptions]="{standalone: true}" class="me-2 m-w-auto" />
                    <i class="material-icons me-2 star" *ngIf="(item.is_f==1)">star_rate</i>
                    <div class="u-img me-2" [appBackgroundImg]="item.profile_picture"></div>
                    <div> {{ item.first_name }} {{ item.last_name }}</div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="dress_code">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.DRESSCODE" | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <mat-select class="form-control" placeholder="Select Dress Code" [(ngModel)]="element.dr_c"
            style="max-width: 230px !important;">
            <mat-option *ngFor="let item of dressCodeArr" [value]="item.dr_c">{{item.dr_c}}</mat-option>
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef class="user"> {{"RECRUITER.ADDSHIFT.NOTES" | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <input type="text" class="form-control" placeholder="Notes" [(ngModel)]="element.notes">
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> {{"COMMON.ACTION" | translate}}</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div (click)="onDeleteItem(i)" class="cursor-pointer">
            <img src="assets/images/icons/delete.png" class="img-fluid" alt="">
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div class="m-auto my-4 text-center">
      <button mat-raised-button color="warn" class="auth-form-btn  success-btn ms-3" type="submit"
        (click)="onAddMore()">
        <i class="fas fa-plus me-2"></i>Add More</button>
    </div>
  </div>
  <div class="row item-footer">
    <div class="col-md-6  offset-md-6">
      <div class="text-left " style="text-align: right;">
        <mat-error *ngIf="errorMessage">{{errorMessage}}</mat-error>
      </div>
      <div class="d-flex justify-content-end align-items-center m-container">
        <button type="button"
          class="auth-form-btn btn-outline-primary d-flex align-items-center justify-content-center me-4 mt-3"
          (click)="onCancel()">{{"Cancel" |translate}}</button>
        <button mat-raised-button color="primary" class="auth-form-btn  no-sh-btn mt-3" type="submit"
          (click)="onSave()">{{"Save"|translate}}</button>
      </div>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>